import { EventEmitter, Injectable, Output, Directive } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service';
import { ErrorService } from '@app/core/error/error.service';
import { Router } from '@angular/router';
import { Airport } from '../model/airport.model';
import { EntityCV } from '@app/shared/model/cv/EntityCV.model';
import { AbstractEntityService } from '@app/shared/service/base/abstractEntityService';
import { SpinnerService } from '@app/core/spinner/spinner.service';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class AirportService extends AbstractEntityService {

  @Output() defaultAirportChange = new EventEmitter<Airport>();

  baseApiUrl = 'api';

  defaultAirport: Airport;

  constructor(
    public httpClient: HttpClient,
    public environmentService: EnvironmentService,
    public errorService: ErrorService,
    public router: Router,
    public spinner: SpinnerService
  ) {
    super(httpClient, environmentService, router, errorService);
  }

  getEntityName(): string {
    return EntityCV.all.AIRPORT;
  }

  // getIdFromEntity(airport: Airport): any {
  //   return airport.id;
  // }

  getURLIdFromEntity(airport: Airport): string {
    return String(airport.id);
  }

  getURLCoeFromEntity(airport: Airport): string {
    return String(airport.iataCode);
  }

  setDefaultAirport(airport: Airport): void {
    if (!this.defaultAirport || this.defaultAirport.iataCode !== airport.iataCode) {
      const airportString = JSON.stringify(airport);
      localStorage.setItem('defaultAirport', airportString);
      this.defaultAirportChange.emit(airport);
    }
  }

  removeDefaultAirport(): void {
    localStorage.removeItem('defaultAirport');
    this.defaultAirportChange.emit(null);
}

  getDefaultAirport(): Airport {
    if (this.defaultAirport) {
      return this.defaultAirport;
    } else {
      const airportString = localStorage.getItem('defaultAirport');
      if (airportString) {
        return JSON.parse(airportString) as Airport;
      } else {
        return null;
      }
    }
  }

}
